import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import InputField from 'yoda-checkout-components/lib/components/CustomTags/InputField/InputField';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as getOrderTotals from '../../../../actions/OrderTotalsAction';

/* istanbul ignore next */
const VoucherNumberForm = (props) => {
    const { b2bVoucher } = props;
    if (b2bVoucher !== TokenProvider.get('Voucher_Number')) {
        TokenProvider.set('Voucher_Number', b2bVoucher);
    }
    const onChangeInput = (inputField, value) => {
        const prevPageEvents = LocalStorage.getData('analytics_PrevPageEvents', true) || '{}';
        let eventList;
        try {
            eventList = JSON.parse(prevPageEvents).eventList || [];
        } catch {
            eventList = [];
        }
        const trackingData = {
            module: {
                name: 'checkout : shoppingcart : VoucherNumber',
                linktext: 'Voucher Number',
                locationpath: '/checkout/payment',
                targetpath: '',
                linkposition: '0',
            },
        };
        const pageEvents = {
            eventName: 'moduletracking',
            pageInfo: {
                analyticsPageName: window.digitalData?.page?.pageInfo?.pageName,
                pageType: window.digitalData?.page?.pageInfo?.pageType,
            },
            ...trackingData,
        };

        eventList.push(pageEvents);
        const analyticsData = { eventList };
        LocalStorage.setData('analytics_PrevPageEvents', analyticsData, true);

        const orderTotals = {};
        orderTotals.voucherNumber = value;
        props.actions.getOrderTotals(orderTotals);
        // setting voucher number to local session
        TokenProvider.set(inputField, value);
    };
    return (
        <div
            className={`${dt([
                'bg-white',
                'inline-block',
                'w-full',
                'h-full',
                'pt-6',
                'relative',
                'top-[10px]',
            ])}`}
            automationId="div-voucher-number"
        >
            <InputField
                name="voucherNumber"
                id="voucherNumber"
                automationId="at-voucher-input"
                placeholder="Voucher Number (optional)"
                value={b2bVoucher || TokenProvider.get('Voucher_Number') || ''}
                onChange={(value) => {
                    onChangeInput('Voucher_Number', value);
                }}
                maxLength={20}
                type="tel"
                wrapperTheme={dt(['mt-0'])}
            />
        </div>
    );
};

/* istanbul ignore next */
const mapStateToProps = ({ state }) => ({});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...getOrderTotals }, dispatch),
});

VoucherNumberForm.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherNumberForm);
